import { NgClass } from '@angular/common'
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldWrapper, FormlyModule } from '@ngx-formly/core'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'formly-wrapper-panel',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, NgClass, SvgIconComponent],
  templateUrl: './input-field-wrapper.component.html',
})
export class InputFieldWrapperComponent extends FieldWrapper implements OnInit {
  public isPassword: boolean = false
  public hasFocus: boolean = false
  @ViewChild('wrapperRef') private readonly wrapperRef!: ElementRef

  public constructor() {
    super()
  }

  public ngOnInit(): void {
    this.isPassword = this.field.type === 'password'
  }

  public clearField(): void {
    if (this.field.props?.disabled) return
    this.formControl.setValue(null)
  }

  public togglePasswordVisibility(): void {
    if (this.field.props?.disabled) return
    this.field.type = this.field.type === 'password' ? 'text' : 'password'
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const isInside = this.wrapperRef.nativeElement.contains(event.target)

    if (isInside) {
      this.hasFocus =
        (event.target as HTMLElement).tagName === 'INPUT' ||
        (event.target as HTMLElement).tagName === 'IMG'
    } else {
      this.hasFocus = false
    }
  }
}
